var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, ModelSync } from 'vue-property-decorator';
import { BFormGroup, BFormSelect } from 'bootstrap-vue';
import axios from 'axios';
import groupBy from 'lodash/groupBy';
let StandardSizeSelector = class StandardSizeSelector extends Vue {
    constructor() {
        super(...arguments);
        this.standardSizes = {};
    }
    get sizeOptions() {
        return [
            { label: 'A Sizes', options: this.standardSizes.a },
            { label: 'CM Sizes', options: this.standardSizes.cm },
            { label: 'Inch Sizes', options: this.standardSizes.inch },
            { label: 'Square Sizes', options: this.standardSizes.square }
        ];
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the standard sizes
            let { data } = yield axios.get('/api/sizes/all');
            this.standardSizes = groupBy(data.map(size => {
                const sizeType = size.type == 'inch' && size.size.length == size.size.width ? 'square' : size.type;
                return {
                    value: {
                        width: size.size.width,
                        length: size.size.length,
                        name: size.name,
                        type: sizeType
                    },
                    text: size.name,
                    type: sizeType
                };
            }), 'type');
        });
    }
};
__decorate([
    ModelSync('size', 'change', { type: Object })
], StandardSizeSelector.prototype, "selectedSize", void 0);
StandardSizeSelector = __decorate([
    Component({
        components: {
            BFormGroup, BFormSelect
        }
    })
], StandardSizeSelector);
export default StandardSizeSelector;
